import React, { useState, useRef, useEffect } from "react";
import {
  Typography,
  Grid,
  FormControl,
  MenuItem,
  Select,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/styles";

import axios from "axios";

import { dashboardStyle } from "../../Invoices/Components/InvoiceDetails/style";
import UsersByRole from "../NewInvoice/Dropdowns/UsersByRole";
import UsersByRoleMulti from "../NewInvoice/Dropdowns/UsersByRoleMulti";

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const useStyles = makeStyles(dashboardStyle);

const GeneralSetting = ({ formState, setFormState, saveData }) => {
  const getData = () => {
    const axios = require("axios");

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/api/AdminSettings/GetGeneralInfo`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
    };

    axios
      .request(config)
      .then((response) => {

        let old = {
          old_SessionTimeOut: response.data.old_SessionTimeOut,
          old_SkipIPAddress: response.data.old_SkipIPAddress,
          old_EnableAuditAccessLog: response.data.old_EnableAuditAccessLog,
          old_PromptLogin: response.data.old_PromptLogin,
          old_LOAMSection: response.data.old_LOAMSection,
          old_TwoFactorAuthEnabled: response.data.old_TwoFactorAuthEnabled,
          old_SODReviewer: response.data.old_SODReviewer,
          old_ManagerTreasury: response.data.old_ManagerTreasury,
          old_VFPaymentProcessor: response.data.old_VFPaymentProcessor,
          old_APSupervisor: response.data.old_APSupervisor,
          old_APManager: response.data.old_APManager,
          old_APGM: response.data.old_APGM,
          old_APDirector: response.data.old_APDirector,
          old_LOAMSectionList: [],
          sessionTimeOut: [],
          skipIPAddress: [],
          enableAuditAccessLog: [],
          promptLogin: [],
          loamSection: [],
          twoFactorAuthEnabled: [],
          sodReviewer: [],
          managerTreasury: [],
          vfPaymentProcessor: [],
          apSupervisor: "",
          apManager: "",
          apgm: "",
          apDirector: "",
          loamSectionList: [],
        };
        let stateUpdate = {
          old_SessionTimeOut: response.data.old_SessionTimeOut,
          old_SkipIPAddress: response.data.old_SkipIPAddress,
          old_EnableAuditAccessLog: response.data.old_EnableAuditAccessLog,
          old_PromptLogin: response.data.old_PromptLogin,
          old_LOAMSection: response.data.old_LOAMSection,
          old_TwoFactorAuthEnabled: response.data.old_TwoFactorAuthEnabled,
          old_SODReviewer: response.data.old_SODReviewer,
          old_ManagerTreasury: response.data.old_ManagerTreasury,
          old_VFPaymentProcessor: response.data.old_VFPaymentProcessor,
          old_APSupervisor: response.data.old_APSupervisor,
          old_APManager: response.data.old_APManager,
          old_APGM: response.data.old_APGM,
          old_APDirector: response.data.old_APDirector,
          old_LOAMSectionList: [],
          sessionTimeOut: [],
          skipIPAddress: [],
          enableAuditAccessLog: [],
          promptLogin: [],
          loamSection: response.data.old_LOAMSection,
          twoFactorAuthEnabled: response.data.old_TwoFactorAuthEnabled,
          sodReviewer: response.data.old_SODReviewer,
          managerTreasury: response.data.old_ManagerTreasury,
          vfPaymentProcessor: response.data.old_VFPaymentProcessor,
          apSupervisor: response.data.old_APSupervisor,
          apManager: response.data.old_APManager,
          apgm: response.data.old_APGM,
          apDirector: response.data.old_APDirector,
          loamSectionList: [],
        };
        saveData(old);
        setFormState(stateUpdate)
      })
      .catch((error) => {

      });
  };

  useEffect(() => {
    getData();
  }, []);
  const classes = useStyles();

  const [multipleData, setMultipleData] = useState({
    LOAMApprover: [],
  });
  useEffect(() => {
    getRefrenceDataList("LOAMApprover", "LOAMApprover", setMultipleData);
  }, []);
  const getRefrenceDataList = async (refKey, name, setMultipleData) => {
    const data = {
      refKey,
    };
    await axios({
      method: "get", //you can set what request you want to be
      url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetRefrenceDatList_v1`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
      params: data,
    })
      .then(async (res) => {

        const transformedArray = res.data.map((obj) => {
          const {
            IsActive,
            ReferenceCode,
            ReferenceId,
            ReferenceKey,
            ReferenceProp1,
            ReferenceProp2,
            ReferenceProp3,
            ReferenceProp4,
            ReferenceText,
          } = obj;

          return {
            referenceId: Number(ReferenceId),
            referenceKey: ReferenceKey,
            referenceCode: ReferenceCode,
            referenceText: ReferenceText,
            referenceProp1: ReferenceProp1,
            referenceProp2: ReferenceProp2,
            referenceProp3: ReferenceProp3,
            referenceProp4: ReferenceProp4,
            isActive: IsActive == 'True' ? true : false,
          };
        });


        setMultipleData((pre) => ({
          ...pre,
          [name]: transformedArray,
        }));
      })
      .catch((err) => { });
  };
  useEffect(() => {

  }, [formState]);
  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: "lightgray", // Change the background color of the control
      ":focus": {
        borderColor: "gray", // Change the background color on hover
        boxShadow: "black !important",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: "white", // Change the background color of the selected option
      color: "black",
      ":hover": {
        backgroundColor: "lightgray", // Change the background color on hover
      },
    }),
    menu: (base, state) => ({
      ...base,
      backgroundColor: "white", // Change the background color of the menu
      color: "white", // Change the font color of the menu
    }),
  };
  const changeHandler = (name, value) => {

    setFormState({
      // On autofill we get a stringified value.
      ...formState,
      [name]: [...value],
    });
  };
  const changeSingle = (e) => {
    const { name, value } = e.target;
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
  };
  return (
    <>
      <Grid container mt={0} spacing={2}>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Typography>LOAM Section</Typography>
          <FormControl fullWidth size="small">
            <Select
              displayEmpty
              multiple
              name="loamSection"
              value={[...formState.loamSection]}
              onChange={(event) => {
                // setuserRole(event.target.value);
                const {
                  target: { value, name },
                } = event;

                changeHandler(name, value);
              }}
              style={{ height: 30 }}
              MenuProps={MenuProps}
            >
              <MenuItem value={[]} disabled>
                Select a Value
              </MenuItem>
              {multipleData.LOAMApprover.map((item) => (
                <MenuItem value={item}>
                  {item && `${item?.referenceProp1}-${item?.referenceText}`}
                </MenuItem>
              ))}

              {formState.loamSection == "" ? (
                <>
                  <Typography variant="h6" component="h6" color="error">
                    user role is required
                  </Typography>
                </>
              ) : null}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4} mt={0}>
          <UsersByRole
            label="AP Supervisor"
            apiString="AP Supervisor"
            name="apSupervisor"
            formState={formState}
            changeHandler={changeSingle}
            required={true}
            classes={classes}
            disabled={false}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4} mt={0}>
          <UsersByRole
            label="AP Manager"
            apiString="AP Manager"
            name="apManager"
            formState={formState}
            changeHandler={changeSingle}
            required={true}
            classes={classes}
            disabled={false}
          />
        </Grid>
      </Grid>
      <Grid container mt={0} spacing={2}>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <UsersByRole
            label="AP GM"
            apiString="AP GM"
            name="apgm"
            formState={formState}
            changeHandler={changeSingle}
            required={true}
            classes={classes}
            disabled={false}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <UsersByRoleMulti
            label="Manager Treasury"
            apiString="Manager Treasury"
            nameInstate="managerTreasury"
            refId={formState.old_ManagerTreasury}
            formState={formState}
            changeHandler={changeHandler}
            required={true}

            classes={classes}
            disabled={false}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <UsersByRoleMulti
            label="VF Payment Processor"
            apiString="VF Payment"
            nameInstate="vfPaymentProcessor"
            refId={formState.old_VFPaymentProcessor}
            formState={formState}
            changeHandler={changeHandler}
            required={true}
            classes={classes}
            disabled={false}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <UsersByRole
            label="AP Director"
            apiString="AP Director"
            name="apDirector"
            formState={formState}
            changeHandler={changeSingle}
            required={true}
            classes={classes}
            disabled={false}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default GeneralSetting;
